import { defineStore } from 'pinia'

//ページヘッダー用ストア
export const useStorePageHeadInfo = defineStore('pageHeadInfo', {
  state: () => ({
    jp: '',
    en: ''
  }),
})